define("auth/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _routes.default)(function () {
    this.route('account');
    this.route('trial_plans');
    this.route('forgot_email');
    this.route('login');
    this.route('reset_password');
    this.route('signup');
    this.route('accept_invite', {
      path: '/accept_invite/:invitation_token'
    });
    this.route('accept_membership', {
      path: '/membership/:membership_id'
    });
    this.route('update_password');
    this.route('user-goals', {
      path: '/goals'
    });
    this.route('o-auth', {
      path: '/oauth/later_authorize'
    });
  });

  _exports.default = _default;
});